/**
 * 跨平台图片下载函数
 * @param {string} url - 图片URL
 * @param {string} fileName - 下载文件名(不带扩展名)
 * @returns {Promise<void>}
 */
export function downloadImageCrossPlatform(url, fileName = 'image') {
    return new Promise((resolve, reject) => {
        // 1. 创建Image对象并处理跨域
        const img = new Image();
        img.crossOrigin = 'Anonymous';

        // 添加时间戳避免缓存问题
        const timestampedUrl = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
        img.src = timestampedUrl;

        img.onload = () => {
            try {
                // 2. 创建Canvas处理图片
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                // 3. 转换为Blob
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('图片转换失败'));
                        return;
                    }

                    // 4. 创建下载链接
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;

                    // 根据平台特性设置文件名
                    const ext = getExtensionFromMime(blob.type);
                    link.download = `${fileName}${ext}`;

                    // 5. 触发下载
                    document.body.appendChild(link);
                    link.click();

                    // 6. 清理资源
                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(blobUrl);
                        resolve();
                    }, 100);
                }, 'image/jpeg', 0.92); // 默认使用JPEG格式
            } catch (error) {
                reject(error);
            }
        };

        img.onerror = () => {
            reject(new Error('图片加载失败'));
        };
    });
}

/**
 * 根据MIME类型获取文件扩展名
 * @param {string} mimeType 
 * @returns {string}
 */
function getExtensionFromMime(mimeType) {
    const mimeMap = {
        'image/jpeg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/webp': '.webp'
    };
    return mimeMap[mimeType] || '.jpg';
}

// 导出检测平台函数
export function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

export function sendShakeDataFun() {
    let accelerometerData = {
        x: Math.random() * 1000,
        y: Math.random() * 1000,
        z: Math.random() * 1000,
    };
    let gyroscopeData = {
        x: Math.random() * 1000,
        y: Math.random() * 1000,
        z: Math.random() * 1000,
    };
    // let accelerometerData = generateShakeData();
    // let gyroscopeData = generateShakeData();
    const param = {
        accelerometer: accelerometerData,
        gyroscope: gyroscopeData
    }
    return param
}
// 生成随机摇一摇数据
function generateShakeData(dataPoints = 50, intensity = "medium", includeNoise = true) {
    // 根据强度设置参数
    let baseAmplitude, peakAmplitude;
    switch (intensity) {
        case 'low':
            baseAmplitude = 0.5;
            peakAmplitude = 1.5;
            break;
        case 'high':
            baseAmplitude = 2.0;
            peakAmplitude = 4.0;
            break;
        case 'medium':
        default:
            baseAmplitude = 1.0;
            peakAmplitude = 2.5;
    }

    // 生成时间序列
    const timestamps = [];
    const xData = [];
    const yData = [];
    const zData = [];

    // 生成基本重力数据 (1g)
    for (let i = 0; i < dataPoints; i++) {
        timestamps.push(i);

        // 基础重力数据
        let x = 0;
        let y = 0;
        let z = 1.0; // 默认Z轴朝上

        // 添加随机噪声
        if (includeNoise) {
            x += (Math.random() - 0.5) * 0.1;
            y += (Math.random() - 0.5) * 0.1;
            z += (Math.random() - 0.5) * 0.1;
        }

        // 模拟摇动 - 在中间部分添加峰值
        if (i > dataPoints * 0.3 && i < dataPoints * 0.7) {
            // 计算摇动强度因子 (正弦波)
            const shakeFactor = Math.sin((i - dataPoints * 0.3) / (dataPoints * 0.4) * Math.PI);

            // 生成随机方向的摇动
            const direction = Math.random() * 2 * Math.PI;
            const shakeX = Math.cos(direction) * shakeFactor * peakAmplitude;
            const shakeY = Math.sin(direction) * shakeFactor * peakAmplitude;
            const shakeZ = (Math.random() - 0.5) * shakeFactor * baseAmplitude;

            x += shakeX;
            y += shakeY;
            z += shakeZ;
        }
        let data = {
            x: (x * 1000).toFixed(3),
            y: (y * 1000).toFixed(3),
            z: (z * 1000).toFixed(3),
        }
        return data
    }
}
